import { alpha } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';

export const dataGridStyles: SxProps<Theme> = (theme) => ({
  '& .day-col--today': {
    backgroundColor: alpha(theme.palette.primary.main, 0.08)
  },
  '& .MuiDataGrid-columnHeader.day-col--weekend, & .MuiDataGrid-cell.day-col--weekend':
    {
      backgroundColor: alpha(theme.palette.divider, 0.04)
    },
  '& .MuiDataGrid-columnSeparator': { display: 'none' },
  '& .MuiDataGrid-columnHeader.day-col--sunday, & .MuiDataGrid-cell.day-col--sunday':
    {
      borderRight: `1px solid ${theme.palette.primary.main}`
    },
  '& .MuiDataGrid-columnHeader--filledGroup .MuiDataGrid-columnHeaderTitleContainer':
    {
      borderBottom: 'none'
    },
  '& .MuiDataGrid-columnHeader--filledGroup': {
    borderBottom: `1px solid ${theme.palette.divider}`
  },
  '& .week-col--current': {
    fontFamily: 'SourceSansPro-Bold'
  }
});
